import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {AuthService} from '@app/core/auth/auth.service';
import {DeviceService} from '@app/core/services/device.service';
import {LicenceService} from '@app/core/services/licence.service';
import {NGXLogger} from 'ngx-logger';

@Injectable({
  providedIn: 'root'
})
export class LicenceGuard  {
  constructor(
    private device: DeviceService,
    private licence: LicenceService,
    private log: NGXLogger
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // If a licence is already loaded and the licence is expired, we redirect to the licence screen
    if (this.device.activeDevice?.licence?.isExpired()) {
      this.licence.openLicenceScreen(this.device.activeDevice.licence, this.device.activeDevice.device.id);
      this.log.warn(`Licence expired, opening route "${state.url}" is not allowed`);
      return false;
    } else {
      return true;
    }
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(childRoute, state);
  }

}
